import { useState } from "react";
import { FiSave } from "react-icons/fi";
import axios from "axios";
import Swal from "sweetalert2";
import { FaUserEdit } from "react-icons/fa";
import { FiEyeOff, FiEye } from "react-icons/fi";

export default function ModalSupervisor() {
  const [name, setName] = useState("");
  const [nip, setNip] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phone_number, setPhoneNumber] = useState("");
  const [address, setAddress] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleClickModal = async () => {
    const modal = document.getElementById("modal_supervisor");
    if (modal) {
      modal.showModal();
    }
  };
  const handleClose = () => {
    const modal = document.getElementById("modal_supervisor");
    if (modal) {
      modal.close();
    }
  };
  const handleRegister = async (e) => {
    e.preventDefault();
    const registerPayload = {
      name: name,
      nip: nip,
      email: email,
      password: password,
      phone_number: phone_number,
      address: address,
    };
    try {
      setIsLoading(true);
      const token = localStorage.getItem("token");
      const requestPayload = await axios.post(
        "https://pln-backend.vercel.app/v1/api/users/register/supervisor",
        registerPayload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const responsePayload = requestPayload.data;

      setIsLoading(false);
      if (responsePayload.status_info) {
        setIsLoading(false);
        handleClose();
        Swal.fire({
          title: "Accepted",
          text: `${responsePayload.message}`,
          icon: "success",
        });
      } else {
        handleClose();
        Swal.fire({
          title: "Warning",
          text: `${responsePayload.message}`,
          icon: "warning",
        });
      }
    } catch (error) {
      setIsLoading(false);
      handleClose();
      Swal.fire({
        title: "Failed",
        text: `${error.response.data.message}`,
        icon: "error",
      });
    }
  };

  const handleShowPasswords = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <button
        className="py-[6px] rounded-full flex gap-2 text-center md:static right-6 md:right-5 items-center md:py-1 text-gray-400 text-[12px] "
        onClick={handleClickModal}
      >
        <FaUserEdit /> supervisor
      </button>
      <dialog id="modal_supervisor" className="modal overflow-auto ">
        <div className="modal-overlay flex justify-center">
          <div className="modal-box w-[95%] md:w-[600px] max-w-none mt-[30px] mb-[30px] max-h-none rounded-2xl pb-14">
            <button
              className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
              onClick={handleClose}
            >
              ✕
            </button>

            <h3 className="font-black text-3xl pb-5">Supervisor</h3>
            <form
              onSubmit={handleRegister}
              className="bg-[#eff3f8] rounded-2xl flex items-center flex-col md:px-[5rem] px-1 py-5 gap-4"
            >
              <div className="flex w-[90%] gap-3">
                <p className="w-1/5 py-1 text-[14px]">Nama</p>
                <input
                  type="text"
                  className="w-[80%] py-1 px-3 rounded-lg bg-white focus:border-[none] outline-none"
                  placeholder="Nama"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="flex w-[90%] gap-3">
                <p className="w-1/5 py-1 text-[14px]">Nip</p>
                <input
                  type="text"
                  className="w-[80%] py-1 px-3 rounded-lg bg-white focus:border-[none] outline-none"
                  placeholder="Nip"
                  value={nip}
                  onChange={(e) => setNip(e.target.value)}
                />
              </div>
              <div className="flex w-[90%] gap-3">
                <p className="w-1/5 py-1 text-[14px]">Email</p>
                <input
                  type="text"
                  className="w-[80%] py-1 px-3 rounded-lg bg-white focus:border-[none] outline-none"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="flex w-[90%] gap-3 relative">
                <p className="w-1/5 py-1 text-[14px]">Password</p>
                <span className="flex justify-between w-[80%] ">
                  <input
                    type={`${showPassword ? "text" : "password"}`}
                    className="w-[85%] py-1 px-3 rounded-lg bg-white focus:border-[none] outline-none"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button
                    onClick={handleShowPasswords}
                    type="button"
                    className="bg-white px-2 rounded-lg"
                  >
                    {showPassword ? <FiEye /> : <FiEyeOff />}
                  </button>
                </span>
              </div>
              <div className="flex w-[90%] gap-3">
                <p className="w-1/5 py-1 text-[14px]">Nomor HP</p>
                <input
                  type="text"
                  className="w-[80%] py-1 px-3 rounded-lg bg-white focus:border-[none] outline-none"
                  placeholder="Nomor HP"
                  value={phone_number}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
              </div>
              <div className="flex w-[90%] gap-3">
                <p className="w-1/5 py-1 text-[14px]">Alamat</p>
                <input
                  type="text"
                  className="w-[80%] py-1 px-3 rounded-lg bg-white focus:border-[none] outline-none"
                  placeholder="Alamat"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </div>

              <div className="flex w-[90%] gap-3 justify-end">
                <button
                  className="flex items-center w-[170px] justify-between bg-[#393E46] rounded-xl px-5 py-1 text-white"
                  type="submit"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <span className="flex items-center justify-center w-full">
                      <p>Loading...</p>
                    </span>
                  ) : (
                    <span className="flex items-center justify-between w-full">
                      <FiSave />
                      <p className="font-thin">Simpan</p>
                    </span>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </dialog>
    </>
  );
}
